/* Vuggis — gift drops from flying sleighs */
(function () {
  if (window.VuggisSleighs) return;
  window.VuggisSleighs = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !Element.prototype.animate) return;
  var MAX = 36;

  function setup(root) {
    if (root._vgs) return; root._vgs = 1;
    var rate = parseFloat(root.getAttribute('data-drops')) || 0; if (!rate) return;
    var gifts = (root.getAttribute('data-gifts') || '').split('|').filter(Boolean); if (!gifts.length) return;
    gifts.forEach(function (src) { var i = new Image(); i.src = src; });
    var layer = root.querySelector('[data-vg-giftlayer]');
    var sleighs = root.querySelectorAll('.vg-sleigh');
    var host = root.parentElement, visible = true, timer = null;
    var every = Math.max(180, 1000 / rate);

    function drop() {
      if (!visible || document.hidden) return;
      if (layer.childElementCount >= MAX) return;
      var hr = host.getBoundingClientRect();
      Array.prototype.forEach.call(sleighs, function (sl, idx) {
        var r = sl.getBoundingClientRect();
        if (r.width === 0 || r.right < hr.left + 20 || r.left > hr.right - 20) return;
        if (parseFloat(getComputedStyle(sl).opacity) < 0.5) return;
        if (idx > 0 && Math.random() < 0.45) return;
        var scale = r.width / 700;
        var size = Math.round((26 + Math.random() * 20) * Math.max(0.55, Math.min(1.25, scale)));
        var x = r.left - hr.left + r.width * (0.08 + Math.random() * 0.08);
        var y = r.top - hr.top + r.height * (0.35 + Math.random() * 0.15);
        var img = document.createElement('img');
        img.className = 'vg-gift'; img.alt = ''; img.src = gifts[Math.floor(Math.random() * gifts.length)];
        img.style.setProperty('--g', size + 'px');
        layer.appendChild(img);
        var fall = Math.max(120, hr.height - y - size * 0.4);
        var dx = -(30 + Math.random() * 110);
        var rot = (Math.random() < 0.5 ? -1 : 1) * (200 + Math.random() * 380);
        var dur = 1900 + fall * 2.2 + Math.random() * 600;
        var a = img.animate([
          { transform: 'translate(' + x + 'px,' + y + 'px) rotate(0deg) scale(.4)', opacity: 0 },
          { transform: 'translate(' + (x + dx * 0.1) + 'px,' + (y + fall * 0.04) + 'px) rotate(' + rot * 0.08 + 'deg) scale(1)', opacity: 1, offset: 0.08 },
          { transform: 'translate(' + (x + dx * 0.85) + 'px,' + (y + fall * 0.92) + 'px) rotate(' + rot * 0.9 + 'deg) scale(1)', opacity: 1, offset: 0.86 },
          { transform: 'translate(' + (x + dx) + 'px,' + (y + fall) + 'px) rotate(' + rot + 'deg) scale(.9)', opacity: 0 }
        ], { duration: dur, easing: 'cubic-bezier(.4,0,.85,.55)', fill: 'forwards' });
        a.onfinish = function () { img.remove(); };
      });
    }
    function start() { if (!timer) timer = setInterval(drop, every); }
    function stop() { clearInterval(timer); timer = null; }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible) start(); else stop(); }, { threshold: 0.05 }).observe(host);
    } else start();
  }
  function init(root) { Array.prototype.forEach.call((root || document).querySelectorAll('[data-vg-sleighs]'), setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();